module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_9016.c3974d91.png";